<div
  class="sp-dialog__min-width"
  style="max-width: 900px">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div
    *ngIf="!is_list_requests_running"
    class="sp-padding__vert-x2">
    <mat-expansion-panel
      *ngFor="let call of integration_calls"
      class="sp-margin__bottom-x2">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h2 class="sp-color__accent">
            {{ call.type?.replaceAll('-', ' ') | uppercase }}
            ({{ call.created_at | date : 'short' }})
          </h2>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div>
        <h3 class="sp-margin__top-x2">Request</h3>
        <pre style="overflow-x: scroll"> {{ getParsedJSON(call.request?.data, call.type) | json }} </pre>

        <h3 class="sp-margin__top-x2">Response</h3>
        <pre style="overflow-x: scroll"> {{ getParsedJSON(call.response?.data) | json }} </pre>
      </div>
    </mat-expansion-panel>
  </div>

  <div
    *ngIf="is_list_requests_running"
    class="sp-column__center sp-width__full sp-padding__x2">
    <mat-spinner
      color="accent"
      diameter="40"></mat-spinner>
    <p class="sp-color__accent sp-text__center sp-margin__top">Loading...</p>
  </div>
</div>
